export enum LogoDimension {
  x72x72 = 1,
  x96x96 = 2,
  x128x128 = 3,
  x144x144 = 4,
  x152x152 = 5,
  x192x192 = 6,
  x384x384 = 7,
  x512x512 = 8,
}
